<div class="main-content">
    <!-- Top Content -->
    <div class="heading-section">
        <h1 class="font-poppins">{{ "contact.heading.contactHeading" | translate }}</h1>
        <p>{{ "contact.heading.subHeading" | translate }}</p>
    </div>
    <!-- Top Content End -->

    <!-- Middle Content  -->
    <div class="middle-section">
        <!-- Contact Details Container -->
        <div class="left-side-content">
            <!-- Contact Info i.e Email, PhNo., Location, Work-hrs -->
            <div class="top-content">
                <h2 class="font-poppins">{{ "contact.heading.contactInfoTitle" | translate }}</h2>

                <div class="contact-title font-inter">
                    <div class="icon-box phone-icon">
                        <mat-icon svgIcon="phone"></mat-icon>
                    </div>
                    <div class="detail">
                        <h5>{{ "contact.label.phone" | translate }}</h5>
                        <span>{{ "contact.contactDetails.phoneNumber" | translate }}</span>
                    </div>
                </div>

                <div class="contact-title font-inter">
                    <div class="icon-box email-icon">
                        <mat-icon svgIcon="email"></mat-icon>
                    </div>
                    <div class="detail">
                        <h5>{{ "contact.label.emailTitle" | translate }}</h5>
                        <span>{{ "contact.contactDetails.emailAddress" | translate }}</span>
                    </div>
                </div>

                <div class="contact-title font-inter">
                    <div class="icon-box location-icon">
                        <mat-icon svgIcon="location"></mat-icon>
                    </div>
                    <div class="detail">
                        <h5>{{ "contact.label.officeLocation" | translate }}</h5>
                        <p>{{ "contact.contactDetails.address" | translate }}</p>
                    </div>
                </div>

                <div class="contact-title font-inter">
                    <div class="icon-box work-icon">
                        <mat-icon svgIcon="clock"></mat-icon>
                    </div>
                    <div class="detail">
                        <h5>{{ "contact.label.workingHours" | translate }}</h5>
                        <div class="days">
                            <span class="bullet open"></span>
                            <p>{{ "contact.contactDetails.weekdays" | translate }}</p>
                        </div>
                        <div class="days">
                            <span class="bullet close"></span>
                            <p>{{ "contact.contactDetails.weekendSat" | translate }}</p>
                        </div>
                        <div class="days">
                            <span class="bullet close"></span>
                            <p>{{ "contact.contactDetails.weekendSun" | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Contact Info End -->

            <!-- Share Section -->
            <div class="bottom-content">
                <div class="icons fb-icon">
                    <mat-icon svgIcon="fb"></mat-icon>
                </div>
                <div class="icons ig-icon">
                    <mat-icon svgIcon="ig"></mat-icon>
                </div>
                <div class="icons twtr-icon">
                    <mat-icon svgIcon="twitter"></mat-icon>
                </div>
            </div>
            <!-- Share Section End -->
        </div>
        <!-- Contact Details End -->

        <!-- Form Section -->
        <div class="right-side-content">
            <div class="title-section">
                <h2 class="font-poppins">{{ "contact.heading.rightHeading" | translate }}</h2>
                <span>
                    {{ "contact.heading.rightSubHeading" | translate }}
                </span>
            </div>

            <div class="form-section">
                <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                    <div class="fields font-inter">
                        <div class="input-field">
                            <label for="name">{{ "contact.label.name" | translate }}</label>
                            <mat-form-field appearance="outline" class="input-custom-style">
                                <input
                                    matInput
                                    id="name"
                                    type="text"
                                    formControlName="name"
                                    autocomplete="off"
                                    [placeholder]="'contact.placeholder.name' | translate"
                                />
                                <mat-error *ngIf="isInvalid('name', 'required')">
                                    {{ "contact.label.name" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </mat-error>
                                <mat-error *ngIf="isInvalid('name', 'forbiddenName')">
                                    {{ "contact.invalidMessage.numberSpecialInvalid" | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="input-field">
                            <label for="email">{{ "contact.label.email" | translate }}</label>
                            <mat-form-field appearance="outline" class="input-custom-style">
                                <input
                                    matInput
                                    id="email"
                                    type="text"
                                    formControlName="email"
                                    autocomplete="off"
                                    [placeholder]="'contact.placeholder.email' | translate"
                                />
                                <mat-error *ngIf="isInvalid('email', 'required')">
                                    {{ "contact.label.email" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </mat-error>
                                <mat-error
                                    *ngIf="isInvalid('email', 'invalidEmail') && !isInvalid('email', 'required')"
                                >
                                    {{ "contact.invalidMessage.emailInvalid" | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="input-field subject">
                            <label for="subject">{{ "contact.label.subject" | translate }}</label>
                            <mat-form-field appearance="outline" class="input-custom-style">
                                <input
                                    matInput
                                    id="subject"
                                    type="text"
                                    formControlName="subject"
                                    autocomplete="off"
                                    [placeholder]="'contact.placeholder.subject' | translate"
                                />
                                <mat-error *ngIf="isInvalid('subject', 'required')">
                                    {{ "contact.label.subject" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="input-field">
                            <label for="message">{{ "contact.label.message" | translate }}</label>
                            <mat-form-field appearance="outline" class="input-custom-style">
                                <textarea
                                    matInput
                                    id="message"
                                    type="text"
                                    formControlName="message"
                                    autocomplete="off"
                                    rows="5"
                                    [placeholder]="'contact.placeholder.message' | translate"
                                ></textarea>
                                <mat-error *ngIf="isInvalid('message', 'required')">
                                    {{ "contact.label.message" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <button [disabled]="this.contactForm.invalid" class="send-btn font-inter">
                            Submit Message <mat-icon svgIcon="send"></mat-icon>
                        </button>
                        <p class="font-inter">{{ "contact.heading.bottomPara" | translate }}</p>
                    </div>
                </form>
            </div>
        </div>
        <!-- Form Section End -->
    </div>
    <!-- Middle Content End -->

    <!-- Bottom Content -->
    <div class="bottom-section">
        <h2 class="font-poppins">{{ "contact.heading.locationTitle" | translate }}</h2>
        <div class="location-point">
            <div>
                <iframe class="map-bg" [src]="locationUrl" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </div>
    </div>
    <!-- Bottom Content End -->
</div>
